import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { UnidadMedidaService } from 'src/app/services/unidadmedida.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { UnidadMedidaModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';

@Component({
  selector: 'app-familia',
  templateUrl: './unidadmedida.component.html',
  styleUrls: ['./unidadmedida.component.scss'],
  providers: [SecurityService],
})
export class UnidadMedidaComponent implements OnInit {

  @ViewChild(UnidadMedidaModalAddEditComponent, { static: true }) modalAddEditUnidadMedida: UnidadMedidaModalAddEditComponent
  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  listaUnidadMedidas: Array<any> = null
  inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loadAll: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private unidadMedidaService: UnidadMedidaService
  ) { }

  ngOnInit() {
    this.createForm()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())

    this.paginationContext.RecordsByPage = 10
    //this.loadOperaciones()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      nombre: [''],
    });
  }

  openModalUnidadMedida() {
    this.modalAddEditUnidadMedida.show()
  }

  loadData() {
    this.listaUnidadMedidas = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        nombre: this.formHeader.get('nombre').value,
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = true
    this.buscar()
  }

  buscar() {
    this.inputParams.paginaActual = this.paginationContext.CurrentPage
    this.unidadMedidaService.obtenerSegunFiltro(this.inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.renderResults(respuesta)
    })
  }

  renderResults({ registros, paginaActual, totalPaginas, totalRegistros }) {
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.listaUnidadMedidas = registros
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  editar(UnidadMedida) {
    this.modalAddEditUnidadMedida.load(UnidadMedida)
  }

  onAddEdit(UnidadMedida) {
    this.loadData()
  }

  desactivar({ codigo }) {
    const inputParams = {
      entidad: {
        codigo,
        activo: false
      }
    }
    this.cambiarEstado(inputParams)
  }

  activar({ codigo }) {
    const inputParams = {
      entidad: {
        codigo,
        activo: true
      }
    }
    this.cambiarEstado(inputParams)
  }

  cambiarEstado(inputParams) {
    this.unidadMedidaService.cambiaEstado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastrService.success('Operación realizada con éxito')
      this.buscar()
    })
  }
}
